import { createContext } from 'react';

export interface DropdownMenuContext {
  activeMenuId?: string;
  setActiveMenuId(id: string): void;
  labelTextWrap: boolean;
  selectedValue?: string;
  setSelectedValue(value?: string): void;
  selectedValues: string[];
  setSelectedValues(values: string[]): void;
  isNested: boolean;
  setIsNested(value: boolean): void;
  resetSelections: () => void;
  applySelections: () => void;
}

export const DropdownMenuContext = createContext<DropdownMenuContext>({
  activeMenuId: undefined,
  setActiveMenuId(): void {},
  labelTextWrap: true,
  selectedValue: undefined,
  setSelectedValue(): void {},
  selectedValues: [],
  setSelectedValues(): void {},
  isNested: false,
  setIsNested(): void {},
  resetSelections(): void {},
  applySelections(): void {}
});
